import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Dialog, Badge } from 'element-react'

import EquipmentFinderDialog from './EquipmentFinderDialog'
import AppRoutes from '../../../routes/appRoutes'
// Icon Images
var requestService = {
    backgroundImage: 'url(/img/nav-svgs/Request_Service.svg)',
}
var requestEquipment = {
    backgroundImage: 'url(/img/nav-svgs/Request_Equipment.svg)',
}
var rentEquipment = { backgroundImage: 'url(/img/nav-svgs/Rent_Equipment.svg)' }
var requestParts = { backgroundImage: 'url(/img/nav-svgs/Request_Parts.svg)' }

export const RequestType = {
    EQUIPMENT: 'equipment',
    RENTAL: 'rental',
    PARTS: 'parts',
    SERVICE: 'service',
}

const RequestDialog = props => {
    let {
        cancel,
        equipmentId,
        serial,
        show,
        linkToSelf,
        onLinkToSelf = () => {},
    } = props

    const [showMiniDialog, setShowMiniDialog] = useState(false)

    // This check fixes an issue with the dialog on IE11.
    return show ? (
        <React.Fragment>
            {!showMiniDialog ? (
                <Dialog
                    className="request-type-dialog"
                    size="large"
                    title=" "
                    visible={true}
                    onCancel={cancel}
                >
                    <Dialog.Body>
                        <div className="row max400">
                            <div className="columns small-12">
                                {/* Dashboard Icons ~~~~~~~~~~~~~~~~~~ */}
                                <div className="dashboard-icons">
                                    <div className="row small-up-2">
                                        {/* Request Service */}
                                        <div className="columns">
                                            <Link
                                                to={{
                                                    pathname: serial
                                                        ? AppRoutes.createRequests(
                                                              serial,
                                                          )
                                                        : AppRoutes.selectAsset(),
                                                    state: {
                                                        source: serial
                                                            ? AppRoutes.fleetAsset(
                                                                  serial,
                                                              )
                                                            : '/requests',
                                                    },
                                                }}
                                                className="link"
                                            >
                                                <span
                                                    className="background-image"
                                                    style={requestService}
                                                />
                                                <h6>Request Repair</h6>
                                            </Link>
                                        </div>
                                        {/* Request Equipment */}
                                        <div className="columns">
                                            <div
                                                onClick={() =>
                                                    setShowMiniDialog(true)
                                                }
                                                className="link"
                                            >
                                                <Badge
                                                    className="dashboard"
                                                    value={'NEW'}
                                                >
                                                    <span
                                                        className="background-image"
                                                        style={requestEquipment}
                                                    />
                                                </Badge>
                                                <h6>Equipment Finder</h6>
                                            </div>
                                        </div>
                                        {/* Rent Equipment */}
                                        <div className="columns">
                                            {linkToSelf ===
                                            RequestType.RENTAL ? (
                                                <a
                                                    onClick={onLinkToSelf}
                                                    className="link"
                                                >
                                                    <span
                                                        className="background-image"
                                                        style={rentEquipment}
                                                    />
                                                    <h6>
                                                        Request Rental Quote
                                                    </h6>
                                                </a>
                                            ) : (
                                                <Link
                                                    to={{
                                                        pathname: AppRoutes.rentalRequests(),
                                                        search: equipmentId
                                                            ? '?equipmentId=' +
                                                              equipmentId
                                                            : '',
                                                        state: {
                                                            source: serial
                                                                ? AppRoutes.fleetAsset(
                                                                      serial,
                                                                  )
                                                                : '/requests',
                                                        },
                                                    }}
                                                    className="link"
                                                >
                                                    <span
                                                        className="background-image"
                                                        style={rentEquipment}
                                                    />
                                                    <h6>
                                                        Request Rental Quote
                                                    </h6>
                                                </Link>
                                            )}
                                        </div>
                                        {/* Request Parts */}
                                        <div className="columns">
                                            {linkToSelf ===
                                            RequestType.PARTS ? (
                                                <a
                                                    onClick={onLinkToSelf}
                                                    className="link"
                                                >
                                                    <span
                                                        className="background-image"
                                                        style={requestParts}
                                                    />
                                                    <h6>Request Parts Quote</h6>
                                                </a>
                                            ) : (
                                                <Link
                                                    to={{
                                                        pathname: AppRoutes.partRequests(),
                                                        search: equipmentId
                                                            ? '?equipmentId=' +
                                                              equipmentId
                                                            : '',
                                                        state: {
                                                            source: serial
                                                                ? AppRoutes.fleetAsset(
                                                                      serial,
                                                                  )
                                                                : '/requests',
                                                        },
                                                    }}
                                                    className="link"
                                                >
                                                    <span
                                                        className="background-image"
                                                        style={requestParts}
                                                    />
                                                    <h6>Request Parts Quote</h6>
                                                </Link>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Dialog.Body>
                </Dialog>
            ) : null}
            {showMiniDialog && (
                <EquipmentFinderDialog
                    show={true}
                    cancel={() => setShowMiniDialog(false)}
                />
            )}
        </React.Fragment>
    ) : null
}

RequestDialog.propTypes = {
    cancel: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    equipmentId: PropTypes.string,
    serial: PropTypes.string,
    linkToSelf: PropTypes.string,
    onLinkToSelf: PropTypes.func,
}

export default RequestDialog
